import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../app';
export let GambitType = /*#__PURE__*/function (GambitType) {
  GambitType["KeyValue"] = "key:value";
  GambitType["Grouped"] = "grouped";
  return GambitType;
}({});
export class BooleanGambit {
  constructor() {
    _defineProperty(this, "type", GambitType.Grouped);
    _defineProperty(this, "predicates", false);
  }
  booleanKey() {
    return 'is';
  }
  groupKey() {
    return app.translator.trans('core.lib.gambits.group_keys.' + this.booleanKey(), {}, true);
  }
  pattern() {
    const is = this.groupKey();
    let key = this.key();
    if (Array.isArray(key)) {
      key = key.join('|');
    }
    return "".concat(is, ":(").concat(key, ")");
  }
  toFilter(_matches, negate) {
    const key = (negate ? '-' : '') + this.filterKey();
    return {
      [key]: true
    };
  }
  fromFilter(value, negate) {
    const is = this.groupKey();
    const key = this.key();
    return "".concat(negate ? '-' : '').concat(is, ":").concat(key);
  }
  suggestion() {
    return {
      group: this.groupKey(),
      key: this.key()
    };
  }
  enabled() {
    return true;
  }
}
export class KeyValueGambit {
  constructor() {
    _defineProperty(this, "type", GambitType.KeyValue);
    _defineProperty(this, "predicates", false);
  }
  valuePattern() {
    return '(.+)';
  }
  gambitValueToFilterValue(value) {
    return value;
  }
  filterValueToGambitValue(value) {
    return Array.isArray(value) ? value.join(',') : value.toString();
  }
  pattern() {
    const key = this.key();
    return "".concat(key, ":") + this.valuePattern();
  }
  toFilter(matches, negate) {
    const key = (negate ? '-' : '') + this.filterKey();
    return {
      [key]: this.gambitValueToFilterValue(matches[1])
    };
  }
  fromFilter(value, negate) {
    return "".concat(negate ? '-' : '').concat(this.key(), ":").concat(this.filterValueToGambitValue(value));
  }
  suggestion() {
    return {
      key: this.key(),
      hint: this.hint()
    };
  }
  enabled() {
    return true;
  }
}
flarum.reg.add('core', 'common/query/IGambit', { GambitType: GambitType,BooleanGambit: BooleanGambit,KeyValueGambit: KeyValueGambit, });